/* GRZ storefront behavior. Shopify / Leadform own their analytics integrations. */
if (!customElements.get('grz-banner')) {
  customElements.define('grz-banner', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.track = this.querySelector('.grz-campaign__track');
      this.status = this.querySelector('[data-banner-status]');
      if (!this.track || !this.status) return;
      const move = direction => {
        const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
        const next = (index + direction + this.track.children.length) % this.track.children.length;
        this.track.scrollTo({ left: next * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.querySelector('[data-banner-prev]').addEventListener('click', () => move(-1));
      this.querySelector('[data-banner-next]').addEventListener('click', () => move(1));
      this.track.addEventListener('scroll', () => {
        this.status.textContent = `${Math.round(this.track.scrollLeft / this.track.clientWidth) + 1} / ${this.track.children.length}`;
      }, { passive: true });
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
      });
      this.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('.grz-campaign__slide');
        if (slide) this.track.scrollTo({ left: slide.offsetLeft, behavior: 'instant' });
      });
    }
  });
}
(() => {
  function closePanel(details, restoreFocus = false) {
    if (!details?.open) return;
    details.open = false;
    if (typeof removeTrapFocus === 'function') removeTrapFocus(restoreFocus ? details.querySelector('summary') : null);
  }
  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!details.matches?.('[data-grz-panel]')) return;
    document.documentElement.classList.toggle('grz-panel-open', Boolean(document.querySelector('[data-grz-panel][open]')));
    if (details.open) {
      document.querySelectorAll('[data-grz-panel][open]').forEach(other => { if (other !== details) closePanel(other); });
      const panel = details.querySelector('[data-grz-dialog]');
      const focusTarget = panel?.querySelector('input[type="search"]') || panel?.querySelector('a,button');
      if (panel && typeof trapFocus === 'function') trapFocus(panel, focusTarget || panel);
    }
  }, true);
  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-grz-close]');
    if (closeButton) closePanel(closeButton.closest('[data-grz-panel]'), true);
    document.querySelectorAll('[data-grz-panel][open]').forEach(details => { if (!details.contains(event.target)) closePanel(details); });
    const navDetails = event.target.closest('.grz-menu-panel a');
    if (navDetails) closePanel(navDetails.closest('[data-grz-panel]'));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-grz-panel][open],.grz-nav-dropdown[open]').forEach(details => closePanel(details, true));
  });
  window.addEventListener('resize', () => {
    if (window.matchMedia('(min-width:750px)').matches) document.querySelectorAll('.grz-mobile-menu[open]').forEach(details => closePanel(details));
  }, { passive: true });
  // Keep the separate sticky purchase control in sync with the native product form.
  function syncSticky(sectionId) {
    const section = document.getElementById(`MainProduct-${sectionId}`);
    if (!section) return;
    const sticky = section.querySelector('.sticky-atc');
    const mainButton = section.querySelector(`#product-form-${CSS.escape(sectionId)} [name="add"]`);
    const mainPrice = document.getElementById(`price-${sectionId}`);
    if (!sticky || !mainButton) return;
    const stickyButton = sticky.querySelector('[name="add"]');
    if (stickyButton) {
      stickyButton.disabled = mainButton.disabled;
      stickyButton.setAttribute('aria-disabled', mainButton.getAttribute('aria-disabled') || String(mainButton.disabled));
      const label = stickyButton.querySelector('span');
      const mainLabel = mainButton.querySelector('span');
      if (label && mainLabel) label.textContent = mainLabel.textContent;
    }
    if (mainPrice && sticky.querySelector('.sticky-atc__price')) sticky.querySelector('.sticky-atc__price').innerHTML = mainPrice.innerHTML;
  }
  document.addEventListener('DOMContentLoaded', () => {
    const orderDock = document.querySelector('[data-grz-order-dock]');
    const orderArea = document.querySelector('.grz-c1-purchase .product__info-wrapper') || document.querySelector('.grz-order-area');
    const mainProductPrice = document.querySelector('section[id^="MainProduct-"] .product-page-price');
    if (orderDock && orderArea) {
      const heroOrder = document.querySelector('.grz-c1-hero-buy a[href="#GRZOrder"], .grz-cryo-button[href="#GRZOrder"], .grz-touch-buy[href="#GRZOrder"], .grz-touch-button[href="#GRZOrder"], .grz-a-button[href="#GRZOrder"], .grz-pro-button[href="#GRZOrder"]');
      const footer = document.querySelector('.grz-footer');
      if ('IntersectionObserver' in window) {
        const visible = new Map();
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => visible.set(entry.target, entry.isIntersecting));
          orderDock.hidden = [...visible.values()].some(Boolean);
        }, { threshold: 0, rootMargin: '-72px 0px 0px 0px' });
        observer.observe(orderArea);
        if (heroOrder) observer.observe(heroOrder);
        if (footer) observer.observe(footer);
      }
      if (mainProductPrice) new MutationObserver(() => {
        document.querySelectorAll('[data-grz-linked-price]').forEach(price => { price.innerHTML = mainProductPrice.innerHTML; });
        const dockPrice = orderDock.querySelector('[data-grz-sticky-price]');
        if (dockPrice) dockPrice.innerHTML = mainProductPrice.innerHTML;
      }).observe(mainProductPrice, { childList: true, subtree: true });
    }
    document.querySelectorAll('section[id^="MainProduct-"]').forEach(section => {
      const id = section.dataset.section;
      const button = document.querySelector(`#product-form-${CSS.escape(id)} [name="add"]`);
      if (button) new MutationObserver(() => syncSticky(id)).observe(button, { attributes: true, childList: true, subtree: true });
      const price = document.getElementById(`price-${id}`);
      if (price) new MutationObserver(() => syncSticky(id)).observe(price, { childList: true, subtree: true });
      syncSticky(id);
    });
  });
})();

